export default __webpack_public_path__ + "static/media/google.d1b55983.svg";